export { default } from './ShelfFacets';



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfFacets/index.js